<script lang="ts">
  // was not happy with the sveltestrap toast implementation so I built this one.
  // use toast.showToast(color, message) anywhere to display for five seconds.
  import { toast } from '$lib/stores/toast.svelte';
  import { fade } from 'svelte/transition';
</script>

{#if toast.isOpen}
  <div
    class={['lb-toast', `lb-toast-${toast.color}`]}
    transition:fade={{ duration: 150 }}
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="lb-toast-body">{toast.message}</div>
    <button type="button" class="btn-close" aria-label="dismiss alert" onclick={() => toast.hideToast()}></button>
  </div>
{/if}

<style>
  .lb-toast {
    --lb-toast-text-color: var(--bs-primary-text-emphasis);
    --lb-toast-bg-color: var(--bs-primary-bg-subtle);
    --lb-toast-border-color: var(--bs-primary-border-subtle);

    display: flex;
    min-width: min(250px, calc(100vw - 2rem));
    font-size: 1rem;
    gap: 1rem;
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    padding: 0.5rem 1rem;
    color: var(--lb-toast-text-color);
    background-color: var(--lb-toast-bg-color);
    border-radius: var(--bs-border-radius);
    border: var(--bs-border-width) solid var(--lb-toast-border-color);
    box-shadow: var(--bs-box-shadow);
    z-index: 1000;
  }

  .lb-toast-primary {
    --lb-toast-text-color: var(--bs-primary-text-emphasis);
    --lb-toast-bg-color: var(--bs-primary-bg-subtle);
    --lb-toast-border-color: var(--bs-primary-border-subtle);
  }

  .lb-toast-secondary {
    --lb-toast-text-color: var(--bs-secondary-text-emphasis);
    --lb-toast-bg-color: var(--bs-secondary-bg-subtle);
    --lb-toast-border-color: var(--bs-secondary-border-subtle);
  }

  .lb-toast-success {
    --lb-toast-text-color: var(--bs-success-text-emphasis);
    --lb-toast-bg-color: var(--bs-success-bg-subtle);
    --lb-toast-border-color: var(--bs-success-border-subtle);
  }

  .lb-toast-danger {
    --lb-toast-text-color: var(--bs-danger-text-emphasis);
    --lb-toast-bg-color: var(--bs-danger-bg-subtle);
    --lb-toast-border-color: var(--bs-danger-border-subtle);
  }

  .lb-toast-warning {
    --lb-toast-text-color: var(--bs-warning-text-emphasis);
    --lb-toast-bg-color: var(--bs-warning-bg-subtle);
    --lb-toast-border-color: var(--bs-warning-border-subtle);
  }

  .lb-toast-info {
    --lb-toast-text-color: var(--bs-info-text-emphasis);
    --lb-toast-bg-color: var(--bs-info-bg-subtle);
    --lb-toast-border-color: var(--bs-info-border-subtle);
  }

  .lb-toast-light {
    --lb-toast-text-color: var(--bs-light-text-emphasis);
    --lb-toast-bg-color: var(--bs-light-bg-subtle);
    --lb-toast-border-color: var(--bs-light-border-subtle);
  }

  .lb-toast-dark {
    --lb-toast-text-color: var(--bs-dark-text-emphasis);
    --lb-toast-bg-color: var(--bs-dark-bg-subtle);
    --lb-toast-border-color: var(--bs-dark-border-subtle);
  }

  .lb-toast-body {
    flex: 1;
  }
</style>
